import React from 'react';

const Image = (props) => {
    const {src, className, alt = '', innerRef, ...rest} = props;

    return <img className={className} src={src} ref={innerRef} alt={alt} {...rest} />;
};

export default Image;
